import { Training } from "@/types/training";
import { createContext, Dispatch, SetStateAction } from "react";

export const initialTrainingsContext = {
    isTrainingsInitialized: false,
    trainings: [] as Training[],
    setTrainings: ((_trainings) => {}) as Dispatch<SetStateAction<Training[]>>,
    trainingsByCategory: {} as Record<string, Training[]>,
    markAsCompleted: (_training: Training) => {},
    incompleteTrainingsCount: 0,
};

export const TrainingsContext = createContext(initialTrainingsContext);
